module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))]), _c('p', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "32px"
    }
  }, [_vm._v("請注意！若為商業使用需經主辦單位同意")])]), _c('div', {
    staticClass: "mb-5"
  }), _c('section'), _c('div', {
    staticClass: "mb-10"
  }), _vm._m(1), _c('div', {
    staticClass: "mb-40"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("2017 WirForce FB 封面圖")]), _c('div', {
    staticClass: "preview-wrap"
  }, [_c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/fb-cover.jpg",
      "download": "fb-cover",
      "title": "fb-cover"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/fb-cover.png")
    }
  })])]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("2017 WirForce 實況素材")]), _c('div', {
    staticClass: "preview-wrap"
  }, [_c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout01.png",
      "download": "live-layout01",
      "title": "live-layout01"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout01.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout02.png",
      "download": "live-layout02",
      "title": "live-layout02"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout02.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout03.png",
      "download": "live-layout03",
      "title": "live-layout03"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout03.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout04.png",
      "download": "live-layout04",
      "title": "live-layout04"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout04.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout05.png",
      "download": "live-layout05",
      "title": "live-layout05"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout05.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout06.png",
      "download": "live-layout06",
      "title": "live-layout06"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout06.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout07.png",
      "download": "live-layout07",
      "title": "live-layout07"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout07.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout08.png",
      "download": "live-layout08",
      "title": "live-layout08"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout08.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout09.png",
      "download": "live-layout09",
      "title": "live-layout09"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout09.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/live-layout10.png",
      "download": "live-layout10",
      "title": "live-layout10"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/live-layout10.png")
    }
  })])]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("2017 WirForce 桌布")]), _c('div', {
    staticClass: "preview-wrap"
  }, [_c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-01.jpg",
      "download": "wallpaper-01",
      "title": "wallpaper-01"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-01.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-02.jpg",
      "download": "wallpaper-02",
      "title": "wallpaper-02"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-02.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-03.jpg",
      "download": "wallpaper-03",
      "title": "wallpaper-03"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-03.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-04.jpg",
      "download": "wallpaper-04",
      "title": "wallpaper-04"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-04.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-05.jpg",
      "download": "wallpaper-05",
      "title": "wallpaper-05"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-05.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-06.jpg",
      "download": "wallpaper-06",
      "title": "wallpaper-06"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-06.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-07.jpg",
      "download": "wallpaper-07",
      "title": "wallpaper-07"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-07.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-08.jpg",
      "download": "wallpaper-08",
      "title": "wallpaper-08"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-08.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-09.jpg",
      "download": "wallpaper-09",
      "title": "wallpaper-09"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-09.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-10.jpg",
      "download": "wallpaper-10",
      "title": "wallpaper-10"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-10.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-11.jpg",
      "download": "wallpaper-11",
      "title": "wallpaper-11"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-11.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/wallpaper-12.jpg",
      "download": "wallpaper-12",
      "title": "wallpaper-12"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/wallpaper-12.png")
    }
  })])]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("2017 WirForce logo")]), _c('div', {
    staticClass: "preview-wrap"
  }, [_c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/logo-01.png",
      "download": "logo-01",
      "title": "logo-01"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/logo-01.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/logo-02.png",
      "download": "logo-02",
      "title": "logo-02"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/logo-02.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/logo-03.png",
      "download": "logo-03",
      "title": "logo-03"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/logo-03.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/logo-04.png",
      "download": "logo-04",
      "title": "logo-04"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/logo-04.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/logo-05.png",
      "download": "logo-05",
      "title": "logo-05"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/logo-05.png")
    }
  })])]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("2017 WirForce 海報")]), _c('div', {
    staticClass: "preview-wrap"
  }, [_c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/post-01.jpg",
      "download": "post-01",
      "title": "post-01"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/post-01.png")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://img.wirforce.com.tw/download/post-02.jpg",
      "download": "post-02",
      "title": "post-02"
    }
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": require("assets/download/post-02.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00616eb8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/download.vue
// module id = 555
// module chunks = 1